export const SALES_TEXT = Object.freeze({
  page: {
    title: 'Negocios',
    subtitle: 'Gestión de negocios y seguimiento comercial',
    table: {
      empty: 'Sin negocios disponibles para los filtros seleccionados.',
    },
    headerActions: {
      newSale: 'Nuevo',
      importSales: 'Importar',
    },
    confirm: {
      delete: {
        title: 'Eliminar negocio',
        subtitle: 'Esta acción eliminará el negocio seleccionado.',
        confirm: 'Eliminar',
      },
    },
    toasts: {
      importPending: 'El flujo para importar negocios se conectará en el siguiente paso.',
      createError: 'No fue posible registrar el negocio.',
      createSuccess: 'El negocio ha sido registrado correctamente.',
      updateError: 'No fue posible actualizar el negocio.',
      updateSuccess: 'El negocio ha sido actualizado correctamente.',
    },
    actionMessages: {
      loadStatusOptionsError: 'No fue posible cargar los estados de negocio.',
      updateStatusError: 'No fue posible actualizar el estado del negocio.',
      updateStatusSuccess: 'El estado del negocio ha sido actualizado correctamente.',
      updateError: 'No fue posible actualizar el negocio.',
      updateSuccess: 'El negocio ha sido actualizado correctamente.',
      loadEditError: 'No fue posible cargar el detalle del negocio para edición.',
      deleteError: 'No fue posible eliminar el negocio.',
      deleteSuccess: 'El negocio ha sido eliminado correctamente.',
    },
    metrics: {
      total: 'Total',
      openTotal: 'Total negocios abiertos',
      newBusinesses: 'Nuevos negocios',
      latestSale: 'ÚLTIMO NEGOCIO CREADO',
      latestSaleDatePrefix: 'Fecha de creación:',
    },
  },
  modal: {
    closeAriaLabel: 'Cerrar modal',
    sectionsAriaLabel: 'Secciones del formulario de negocio',
    title: {
      business: {
        create: 'Nuevo negocio',
        edit: 'Editar negocio',
      },
      multiCustomer: {
        create: 'Nuevo negocio multicliente',
        edit: 'Editar negocio multicliente',
      },
      flatRate: {
        create: 'Nueva iguala',
        edit: 'Editar iguala',
      },
    },
    subtitle: {
      business: {
        create: 'Captura rápida para crear un negocio.',
        edit: 'Actualiza la información principal del negocio.',
      },
      multiCustomer: {
        create: 'Captura rápida para crear un negocio multicliente.',
        edit: 'Actualiza la información del negocio multicliente seleccionado.',
      },
      flatRate: {
        create: 'Captura rápida para crear una iguala.',
        edit: 'Actualiza la información principal de la iguala.',
      },
    },
    actions: {
      cancel: 'Cancelar',
      submitCreate: 'Guardar',
      submitEdit: 'Actualizar',
      submitting: 'Guardando...',
      delete: {
        business: 'Eliminar negocio',
        multiCustomer: 'Eliminar negocio multicliente',
        flatRate: 'Eliminar iguala',
      },
    },
    sections: {
      general: {
        title: 'Información General',
        description: 'Datos base del negocio, cliente y montos.',
      },
      configuration: {
        title: 'Gestión Operativa',
        description: 'Responsables, etiquetas y seguimiento.',
      },
      details: {
        title: 'Detalles',
        description: 'Alcance y comentarios del negocio.',
      },
      quote: {
        title: 'Cotización',
        description: 'Origen y referencias de cotización.',
      },
    },
    validation: {
      saleNameRequired: 'El nombre del negocio es obligatorio.',
      serviceRequired: 'Selecciona un servicio.',
      customerRequired: 'Selecciona un cliente.',
      customersRequired: 'Selecciona al menos un cliente.',
      paymentsCountRequired: 'La cantidad de planes de pago debe ser mayor a 0.',
      firstInstallmentRequired: 'Selecciona la primera mensualidad.',
      periodicityRequired: 'Selecciona la periodicidad del plan de pagos.',
    },
    statusDefaults: {
      preferredCodes: ['activo', 'abierto'],
    },
    placeholders: {
      emptyOption: 'Selecciona opción',
    },
    common: {
      noOption: 'Sin opción disponible',
    },
    content: {
      general: {
        header: {
          title: 'Información General',
          description: 'Datos clave del negocio, cliente, fechas e importes.',
        },
        fields: {
          code: 'Código',
          nameRequired: 'Nombre *',
          serviceRequired: 'Servicio *',
          saleDate: 'Fecha del negocio',
          deliveryDate: 'Fecha de entrega',
          subtotal: 'Subtotal',
          budgetGeneral: 'Presupuesto General',
          mediaAmount: 'Importe Pauta',
          agencyAmount: 'Importe Agencia',
        },
        placeholders: {
          code: 'AB',
          name: 'Nombre del negocio',
          service: 'Selecciona servicio',
          date: 'Selecciona fecha',
          today: 'Hoy',
        },
        amounts: {
          title: 'Importes del negocio',
          description: 'Montos base, presupuesto y desglose comercial.',
        },
      },
      configuration: {
        header: {
          title: 'Gestión Operativa',
          description: 'Responsables y etiquetas.',
        },
        fields: {
          seller: 'Vendedor',
          manager: 'Responsable',
          tags: 'Etiquetas',
          status: 'Estado',
          area: 'Área',
        },
        placeholders: {
          seller: 'Selecciona vendedor',
          manager: 'Selecciona responsable',
          tags: 'Selecciona o agrega etiquetas',
          tagsAdd: 'Agregar etiqueta',
          status: 'Selecciona estado',
          area: 'Selecciona área',
        },
      },
      details: {
        header: {
          title: 'Detalles',
          description: 'Información adicional de alcance y observaciones.',
        },
        fields: {
          scope: 'Alcance',
          comments: 'Comentarios',
        },
        placeholders: {
          scope: 'Alcance del negocio',
          comments: 'Comentarios',
        },
      },
      quote: {
        header: {
          title: 'Cotización',
          description: 'Configura la fuente de cotización y relaciones principales o adicionales.',
        },
        fields: {
          quoteType: 'Tipo de cotización',
          format: 'Formato',
          quote: 'Cotización',
          quotePrincipal: 'Cotización principal',
          quoteExtras: 'Cotizaciones extra',
        },
        options: {
          url: 'URL',
          file: 'Archivo',
        },
        placeholders: {
          quoteType: 'Selecciona tipo de cotización',
          quoteUrl: 'https://...',
          quotePrincipal: 'Selecciona cotización principal',
          quoteExtras: 'Selecciona cotizaciones extra',
        },
        file: {
          select: 'Seleccionar archivo',
          none: 'Ningún archivo seleccionado',
        },
      },
    },
  },
  customerDetail: {
    sales: {
      entityLabel: 'Negocio',
      emptyText: 'Sin negocios disponibles para los filtros seleccionados.',
      deleteModal: {
        title: 'Eliminar negocio',
        subtitle: 'Esta acción eliminará el negocio seleccionado.',
        confirm: 'Eliminar',
      },
      actionMessages: {
        loadStatusOptionsError: 'No fue posible cargar los estados de negocio.',
        updateStatusError: 'No fue posible actualizar el estado del negocio.',
        updateStatusSuccess: 'El estado del negocio ha sido actualizado correctamente.',
        updateError: 'No fue posible actualizar el negocio.',
        updateSuccess: 'El negocio ha sido actualizado correctamente.',
        loadEditError: 'No fue posible cargar el negocio para edición.',
        deleteError: 'No fue posible eliminar el negocio.',
        deleteSuccess: 'El negocio ha sido eliminado correctamente.',
      },
    },
    multiCustomer: {
      entityLabel: 'Negocio multicliente',
      emptyText: 'Sin negocios multicliente disponibles para los filtros seleccionados.',
      deleteModal: {
        title: 'Eliminar negocio multicliente',
        subtitle: 'Esta acción eliminará el negocio multicliente seleccionado.',
        confirm: 'Eliminar',
      },
      actionMessages: {
        loadStatusOptionsError: 'No fue posible cargar los estados de negocio.',
        updateStatusError: 'No fue posible actualizar el estado del negocio multicliente.',
        updateStatusSuccess: 'El estado del negocio multicliente ha sido actualizado correctamente.',
        updateError: 'No fue posible actualizar el negocio multicliente.',
        updateSuccess: 'El negocio multicliente ha sido actualizado correctamente.',
        loadEditError: 'No fue posible cargar el negocio para edición.',
        deleteError: 'No fue posible eliminar el negocio multicliente.',
        deleteSuccess: 'El negocio multicliente ha sido eliminado correctamente.',
      },
    },
  },
  detail: {
    loading: 'Cargando detalle del negocio...',
    sectionTabsAriaLabel: 'Secciones del negocio',
    moreActions: 'Más acciones',
    labels: {
      multiCustomer: 'Multicliente',
      noStatus: 'Sin estado',
      inactiveStatus: 'inactivo',
      documentsTab: 'Documentos',
      noName: 'Sin nombre',
    },
    headerActions: {
      editSale: 'Editar',
      saleSheet: 'Ficha',
      newPaymentPlan: 'Nuevo plan de pagos',
      newExpense: 'Nuevo gasto',
      newFee: 'Nueva comisión',
      addCalendar: 'Agregar a calendario',
    },
    metrics: {
      business: 'NEGOCIO',
      income: 'INGRESOS',
      expenses: 'GASTOS',
      commissions: 'COMISIONES',
      utility: 'UTILIDAD',
      margin: 'Margen',
      utilityTotal: 'Utilidad total',
      utilitySubtotal: 'Utilidad subtotal',
      marginTotal: 'Margen total',
      marginSubtotal: 'Margen subtotal',
      subtotal: 'Subtotal',
      transferredTaxes: 'Impuestos',
      withheldTaxes: 'Retenciones',
      total: 'Total',
    },
    tabsPanelFallback: {
      title: 'Sección no disponible',
      subtitle: 'Esta sección no está habilitada en este momento.',
      message: 'Selecciona otra pestaña para continuar.',
    },
    sharedDetailTab: {
      cards: {
        general: 'Información general',
        scope: 'Alcance',
        amounts: 'Importes',
        quotes: 'Cotizaciones',
        comments: 'Comentarios',
      },
      editButtons: {
        general: 'Editar información general',
        scope: 'Editar alcance',
        amounts: 'Editar importes',
        quotes: 'Editar cotizaciones',
        comments: 'Editar comentarios',
      },
      fields: {
        code: 'Folio',
        name: 'Nombre',
        status: 'Estado',
        customer: 'Cliente',
        serviceType: 'Tipo de servicio',
        service: 'Servicio',
        saleDate: 'Fecha de negocio',
        deliveryDate: 'Fecha de entrega',
        seller: 'Vendedor',
        manager: 'Responsable',
        tags: 'Etiquetas',
        area: 'Área',
        subtotal: 'Subtotal',
        budgetGeneral: 'Presupuesto General',
        mediaAmount: 'Pauta',
        agencyAmount: 'Importe agencia',
        quotePrincipal: 'Cotización principal',
        quoteExtras: 'Cotizaciones extra',
        quoteReference: 'Referencia',
      },
      values: {
        pending: 'Pendiente',
        assign: 'Asignar',
        noTags: 'Sin etiquetas',
        noScope: 'Sin alcance',
        noComments: 'Sin comentarios',
        addQuote: 'Agregar cotización',
        noExtraQuotes: 'Sin cotizaciones extra',
        addReference: 'Agregar',
        quoteFilePrefix: 'Archivo:',
      },
    },
    expensesTab: {
      summary: {
        total: 'Total gastos',
        paid: 'Pagados',
        pending: 'Pendientes',
        sections: {
          expenses: 'Gastos',
          paidDone: 'Ya pagado',
          pendingToPay: 'Pendiente por pagar',
        },
        breakdown: {
          subtotal: 'Subtotal',
          transferredTaxes: 'Imp. trasladados',
          withheldTaxes: 'Imp. retenidos',
          total: 'Total',
        },
      },
      actions: {
        clear: 'Limpiar gastos',
        create: 'Nuevo gasto',
        clearShort: 'Limpiar',
        createShort: 'Gasto',
      },
      table: {
        empty: 'No hay gastos asociados a este negocio para los filtros seleccionados.',
      },
      toolbar: {
        searchPlaceholder: 'Buscar por proveedor, concepto o referencia',
        emptyOption: 'Sin opción disponible',
        filtersButtonTitle: 'Filtros',
        searchButtonTitle: 'Buscar',
        dateRangePresets: [
          { key: 'this_month', label: 'Este mes' },
          { key: 'last_month', label: 'Mes anterior' },
          { key: 'this_year', label: 'Año actual' },
          { key: 'last_year', label: 'Año anterior' },
        ],
        allOptionLabels: {
          provider: 'Proveedor: Todos',
        },
        selectionAllLabels: {
          provider: 'Proveedor: Todos',
        },
        filters: {
          provider: {
            label: 'Proveedor',
            placeholder: 'Selecciona proveedor',
            searchable: true,
          },
          expenseClass: {
            label: 'Clase',
            placeholder: 'Selecciona clase',
            searchable: true,
          },
          category: {
            label: 'Categoría',
            placeholder: 'Selecciona categoría',
            searchable: true,
          },
          tags: {
            label: 'Etiquetas',
            placeholder: 'Selecciona etiquetas',
            searchable: true,
          },
          hasXml: {
            label: 'Tiene XML',
            placeholder: 'Selecciona opción',
            searchable: false,
          },
          currency: {
            label: 'Moneda',
            placeholder: 'Selecciona moneda',
            searchable: true,
          },
        },
      },
    },
    feesTab: {
      summary: {
        total: 'Total comisiones',
        paid: 'Pagadas',
        pending: 'Pendientes',
        sections: {
          fees: 'Comisiones',
          paidDone: 'Ya pagado',
          pendingToPay: 'Pendiente por pagar',
        },
        breakdown: {
          subtotal: 'Subtotal',
          transferredTaxes: 'Imp. trasladados',
          withheldTaxes: 'Imp. retenidos',
          total: 'Total',
        },
      },
      actions: {
        clear: 'Limpiar comisiones',
        create: 'Nueva comisión',
        clearShort: 'Limpiar',
        createShort: 'Comisión',
      },
      table: {
        empty: 'No hay comisiones asociadas a este negocio para los filtros seleccionados.',
      },
      toolbar: {
        searchPlaceholder: 'Buscar por colaborador, proveedor o concepto',
        emptyOption: 'Sin opción disponible',
        filtersButtonTitle: 'Filtros',
        searchButtonTitle: 'Buscar',
        dateRangePresets: [
          { key: 'this_month', label: 'Este mes' },
          { key: 'last_month', label: 'Mes anterior' },
          { key: 'this_year', label: 'Año actual' },
          { key: 'last_year', label: 'Año anterior' },
        ],
        allOptionLabels: {
          provider: 'Todos',
          collaborator: 'Colaborador: Todos',
        },
        selectionAllLabels: {
          provider: 'Todos',
          collaborator: 'Colaborador: Todos',
        },
        filters: {
          collaborator: {
            label: 'Colaborador',
            placeholder: 'Selecciona colaborador',
            searchable: true,
          },
          provider: {
            label: 'Proveedor',
            placeholder: 'Selecciona proveedor',
            searchable: true,
          },
          expenseClass: {
            label: 'Clase',
            placeholder: 'Selecciona clase',
            searchable: true,
          },
          category: {
            label: 'Categoría',
            placeholder: 'Selecciona categoría',
            searchable: true,
          },
          tags: {
            label: 'Etiquetas',
            placeholder: 'Selecciona etiquetas',
            searchable: true,
          },
          hasXml: {
            label: 'Tiene XML',
            placeholder: 'Selecciona opción',
            searchable: false,
          },
          currency: {
            label: 'Moneda',
            placeholder: 'Selecciona moneda',
            searchable: true,
          },
        },
      },
    },
    customersTab: {
      summary: {
        metrics: {
          customers: 'CLIENTES',
          averagePerCustomer: 'PROMEDIO POR CLIENTE',
          topIncomePerCustomer: 'MAYOR INGRESO POR CLIENTE',
        },
        actions: {
          clear: 'Limpiar clientes',
          create: 'Nuevo cliente',
        },
      },
      toolbar: {
        searchPlaceholder: 'Buscar por cliente, contacto o email',
        plansPrefix: 'planes de pago:',
        noOption: 'Sin opción disponible',
        plansFilter: {
          all: 'todos',
          with: 'con plan',
          without: 'sin plan',
        },
      },
      table: {
        columns: {
          customer: 'CLIENTE',
          mainContact: 'CONTACTO PRINCIPAL',
          email: 'EMAIL',
          paymentPlans: 'PLANES DE PAGO',
          billed: 'FACTURADO',
          paid: 'PAGADO',
        },
        sortTitles: {
          customer: 'Ordenar por cliente',
          paymentPlans: 'Ordenar por planes de pago',
          billed: 'Ordenar por facturado',
          paid: 'Ordenar por pagado',
        },
        states: {
          loading: 'Cargando clientes...',
          empty: 'Sin clientes disponibles para los filtros seleccionados.',
        },
        actions: {
          viewPlans: 'Ver planes de pago',
          delete: 'Eliminar',
          more: 'Más acciones',
          exportPdf: 'Estado de cuenta PDF',
          exportExcel: 'Estado de cuenta Excel',
        },
      },
      addModal: {
        title: 'Agregar clientes al negocio',
        subtitle: 'Selecciona uno o varios clientes para agregarlos al negocio multicliente.',
        closeAriaLabel: 'Cerrar modal',
        actions: {
          cancel: 'Cancelar',
          submit: 'Agregar clientes',
          submitting: 'Agregando...',
        },
      },
      confirm: {
        delete: {
          title: 'Eliminar cliente del negocio',
          subtitle: 'Esta acción retirará al cliente de este negocio multicliente.',
          confirm: 'Eliminar',
          message: 'Se eliminará {customerName} del negocio multicliente.\nEsta acción solo se permite si no tiene planes de pago asociados.',
          customerFallback: 'este cliente',
        },
        clear: {
          title: 'Limpiar clientes del negocio',
          subtitle: 'Esta acción eliminará clientes sin planes de pago.',
          confirm: 'Limpiar clientes',
          message: 'Se eliminarán todos los clientes de este negocio que no tengan planes de pago registrados.\nEsta acción no afecta a clientes con planes de pago.',
        },
      },
      toasts: {
        clearError: 'No fue posible limpiar clientes del negocio multicliente.',
        clearSuccess: 'Los clientes sin planes de pago fueron eliminados correctamente.',
        addError: 'No fue posible agregar clientes al negocio multicliente.',
        addSuccess: 'Los clientes fueron agregados correctamente.',
        deleteError: 'No fue posible eliminar el cliente del negocio multicliente.',
        deleteSuccess: 'El cliente fue eliminado del negocio multicliente.',
        exportPdfError: 'No fue posible descargar el estado de cuenta en PDF.',
        exportExcelError: 'No fue posible descargar el estado de cuenta en Excel.',
      },
    },
    deleteModal: {
      business: {
        title: 'Eliminar negocio',
        subtitle: 'Esta acción eliminará el negocio seleccionado.',
        messagePrefix: 'Negocio',
      },
      multiCustomer: {
        title: 'Eliminar negocio multicliente',
        subtitle: 'Esta acción eliminará el negocio multicliente seleccionado.',
        messagePrefix: 'Negocio multicliente',
      },
      flatRate: {
        title: 'Eliminar iguala',
        subtitle: 'Esta acción eliminará la iguala seleccionada.',
        messagePrefix: 'Iguala',
      },
      question: '¿Deseas continuar con la eliminación?',
      confirm: 'Eliminar',
    },
    clearExpenses: {
      title: 'Limpiar gastos del negocio',
      confirm: 'Limpiar gastos',
      subtitleApproved: 'Se eliminarán solo los gastos no aprobados.',
      subtitlePaid: 'Se eliminarán solo los gastos sin pago.',
      messageApproved: 'Esta acción eliminará del negocio únicamente gastos no aprobados.\nLos gastos aprobados no se eliminarán.',
      messagePaid: 'Esta acción eliminará del negocio únicamente gastos sin pago.\nLos gastos con pago no se eliminarán.',
    },
    clearFees: {
      title: 'Limpiar comisiones del negocio',
      confirm: 'Limpiar comisiones',
      subtitleApproved: 'Se eliminarán solo las comisiones no aprobadas.',
      subtitlePaid: 'Se eliminarán solo las comisiones sin pago.',
      messageApproved: 'Esta acción eliminará del negocio únicamente comisiones no aprobadas.\nLas comisiones aprobadas no se eliminarán.',
      messagePaid: 'Esta acción eliminará del negocio únicamente comisiones sin pago.\nLas comisiones con pago no se eliminarán.',
    },
    toasts: {
      invalidSale: 'Negocio inválido.',
      loadDetailError: 'No fue posible cargar el detalle del negocio.',
      addCalendarPending: 'Agregar a calendario estará disponible pronto.',
      newPaymentPlanPending: 'Nuevo plan de pagos estará disponible pronto.',
      invoicePlanMissingId: 'No se pudo identificar el plan de pago a facturar.',
      updateBusinessError: 'No fue posible actualizar el negocio.',
      updateBusinessSuccess: 'El negocio ha sido actualizado correctamente.',
      updateFlatRateError: 'No fue posible actualizar la iguala.',
      updateFlatRateSuccess: 'La iguala ha sido actualizada correctamente.',
      updateMultiCustomerError: 'No fue posible actualizar el negocio multicliente.',
      updateMultiCustomerSuccess: 'El negocio multicliente ha sido actualizado correctamente.',
      deleteBusinessError: 'No fue posible eliminar el negocio.',
      deleteBusinessSuccess: 'El negocio ha sido eliminado correctamente.',
      deleteFlatRateError: 'No fue posible eliminar la iguala.',
      deleteFlatRateSuccess: 'La iguala ha sido eliminada correctamente.',
      deleteMultiCustomerError: 'No fue posible eliminar el negocio multicliente.',
      deleteMultiCustomerSuccess: 'El negocio multicliente ha sido eliminado correctamente.',
    },
  },
  shared: {
    common: {
      noOption: 'Sin opción disponible',
      emptySaleName: 'Negocio sin nombre',
    },
    toolbar: {
      searchPlaceholder: 'Buscar por negocio, cliente o servicio',
      filtersTitle: 'Filtros',
      searchTitle: 'Buscar',
      customerAllLabel: 'Cliente: Todos',
      dateRangePresets: [
        { key: 'this_month', label: 'Este mes' },
        { key: 'last_month', label: 'Mes anterior' },
        { key: 'this_year', label: 'Año actual' },
        { key: 'last_year', label: 'Año anterior' },
      ],
      filters: {
        service: { label: 'Servicio', placeholder: 'Selecciona servicio' },
        status: { label: 'Estado', placeholder: 'Selecciona estado' },
        customer: { label: 'Cliente', placeholder: 'Selecciona cliente' },
        seller: { label: 'Vendedor', placeholder: 'Selecciona vendedor' },
        owner: { label: 'Responsable', placeholder: 'Selecciona responsable' },
        area: { label: 'Área', placeholder: 'Selecciona área' },
      },
    },
    statusModal: {
      title: 'Editar estado del negocio',
      subtitle: 'Selecciona el nuevo estado para continuar con el seguimiento comercial.',
      closeAriaLabel: 'Cerrar modal',
      statusLabel: 'Estado',
      statusPlaceholder: 'Selecciona estado',
      guideTitle: 'Guía rápida de estados',
      statuses: {
        open: 'Abierto',
        closed: 'Cerrado',
        canceled: 'Cancelado',
      },
      guide: {
        open: 'negocio activo y editable en cualquier etapa del proceso.',
        closed: 'negocio concluido; se conserva para consulta y ya no se edita.',
        canceled: 'negocio detenido antes de concluirse correctamente; no admite edición.',
      },
      actions: {
        cancel: 'Cancelar',
        submit: 'Actualizar estado',
        submitting: 'Actualizando...',
      },
    },
    table: {
      columns: {
        date: 'FECHA',
        customer: 'CLIENTE',
        sale: 'NEGOCIO',
        service: 'SERVICIO',
        subtotal: 'SUBTOTAL',
        balance: 'SALDO',
        status: 'Estado',
      },
      sortTitles: {
        date: 'Ordenar por fecha',
        customer: 'Ordenar por cliente',
        sale: 'Ordenar por negocio',
        service: 'Ordenar por servicio',
        subtotal: 'Ordenar por subtotal',
        balance: 'Ordenar por saldo',
      },
      loading: 'Cargando negocios...',
      links: {
        customerDetail: 'Ir al detalle del cliente',
        saleDetail: 'Ir al detalle del negocio',
      },
      actions: {
        view: 'Ver negocio',
        edit: 'Editar negocio',
        changeStatus: 'Cambiar estado',
        delete: 'Eliminar',
        more: 'Más acciones',
      },
      exchangeRatePrefix: 'TC:',
    },
    history: {
      title: 'Historial del negocio',
      subtitle: 'Registro cronológico de movimientos y cambios del negocio.',
      loading: 'Cargando historial del negocio...',
      empty: 'Sin movimientos registrados en el historial.',
      fallback: {
        module: 'General',
        event: 'Cambio',
        description: 'Actividad registrada',
        actor: 'Sistema',
      },
    },
    summary: {
      incomeCard: {
        title: 'Progreso de Ingresos',
        subtitle: 'Avance de ingresos cobrados vs ingresos objetivo',
        progressLabel: 'Ejecución de ingresos',
        kpis: {
          target: 'Meta',
          collected: 'Cobrado',
          pending: 'Pendiente',
        },
        defaults: {
          statusLabel: 'Crítico',
        },
      },
      expensesCard: {
        title: 'Progreso de Gastos',
        subtitle: 'Distribución de presupuesto general vs gastos reales',
        progressTotalLabel: 'Gasto total',
        progressPaidLabel: 'Gasto pagado',
        kpis: {
          budget: 'Presupuesto general',
          spentTotal: 'Gasto total',
          spentPaid: 'Gasto pagado',
          available: 'Disponible',
          availableReal: 'Disponible real',
        },
        defaults: {
          statusLabel: 'Saludable',
        },
      },
      businessHealthCard: {
        title: 'Salud del negocio',
        defaults: {
          statusLabel: 'No saludable',
          summary: 'Sin información de salud del negocio.',
        },
      },
      tab: {
        operational: {
          title: 'Información Operativa',
          service: 'Servicio',
          manager: 'Responsable',
          keyDates: 'Fechas clave',
          saleDate: 'Fecha de negocio:',
          deliveryDate: 'Fecha de entrega:',
          assign: 'Asignar',
          defaults: {
            service: 'Implementación ERP Tier 1',
            saleDate: '01 Ago 2024',
            deliveryDate: '15 Dic 2024',
            managerInitials: 'NA',
            healthyStatus: 'Saludable',
            criticalStatus: 'Crítico',
            unhealthyStatus: 'No saludable',
          },
        },
      },
    },
  },
});
